export default __webpack_public_path__ + "static/media/app-explain-people.2f1b0e14.svg";